export default (function (r1, r2) {
  if (r1.offset === r2.offset) {
    return r2.length - r1.length;
  }

  return r1.offset - r2.offset;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-convert/esm/util/rangeSort.js
// module id = 223
// module chunks = 0